import React from "react";
import ReactSpeedometer from "react-d3-speedometer";
import styles from "./MileageSimulatorTab.module.css";

const Speedometer = ({ speedometerValue, analyzed }) => {
  const value = speedometerValue;
  const { savings, energySaved } = analyzed
  // const energySaved = 0; // example value
  // const savings = 0 // example value in INR
  const segmentStops = Array.from({ length: 16 }, (_, i) => i);

  return (
    <div className="d-flex flex-column align-items-center mt-5">
      <div style={{ width: "320px", height: "220px" }}>
        <ReactSpeedometer
          value={value}
          minValue={0}
          maxValue={15}
          segments={15}
          customSegmentStops={segmentStops}
          segmentColors={segmentStops.map(() => "#e6ecfd")}
          needleColor="#1a2a5f"
          needleHeightRatio={0.7}
          ringWidth={20}
          textColor="#122C57"
          currentValueText=""
          needleTransitionDuration={1500}
          needleTransition="easeElastic"
          startColor="#1769b4"
          endColor="#1769b4"
        />
      </div>
      {/* Value and Unit Side by Side */}
      <div className="d-flex align-items-baseline" style={{ marginTop: "-10px" }}>
        <div className={`h4 fw-medium me-2 mb-0 ${styles.speedometerValue}`}>
          {value}
        </div>
        <div className={`h6 fw-normal mb-0 ${styles.speedometerUnit}`}>
          kWh/km
        </div>
      </div>
      {/* Energy Saved */}
      <div className={`small fw-normal mt-1 ${styles.speedometerText}`}>
        Energy Saved: <strong>{energySaved?.toFixed(2) || 0} kWh</strong>
      </div>
      {/* Rupee Savings */}
      <div className={`small fw-normal ${styles.speedometerText}`}>
        Savings: <strong>₹{savings?.toFixed(2) || 0}</strong>
      </div>
    </div>
  );
};

export default Speedometer;